import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step3 } from '../../../../shared/models/component-messages/simp_in/step3';
import { TypeNatureMarcheChoix } from '../models/TypeNatureMarcheChoix';
@Component({
	selector: 'app-type-nature-marche-choix',
	templateUrl: './type-nature-marche-choix.component.html'
})
export class TypeNatureMarcheChoixComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeNatureMarcheChoix';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() natureMarche: TypeNatureMarcheChoix;

	public step3 = new Step3();

	public readonly travauxValue = 'travaux';
	public readonly fournituresValue = 'fournitures';
	public readonly servicesValue = 'services';

	public radioButtonValue: string;
	public radioButtonCtrlName: string;

	constructor() {}

	public ngOnInit() {
		if (this.natureMarche?.travaux === '') {
			this.radioButtonValue = this.travauxValue;
		}
		else if (this.natureMarche?.fournitures === '') {
			this.radioButtonValue = this.fournituresValue;
		}
		else if (this.natureMarche?.services === '') {
			this.radioButtonValue = this.servicesValue;
		}
		this.radioButtonCtrlName = this.getUid() + '_SepAtt_travaux';
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}
}
